
import { css } from 'lit';
export default css`
a {
  border-color: transparent;
  font-weight: 700;
  line-height: 1.25;
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
  text-decoration: none;
}

  a:hover {
  --tw-text-opacity: 1;
  color: rgba(53, 25, 108, var(--tw-text-opacity));
}

  a:hover {
  text-decoration: underline;
}

  a.link--block {
  display: block;
}

  a--icon {
  height: auto;
}

  a--icon {
  width: 100%;
}

  a.link--location-card-directions {
  align-items: center;
}

  a.link--external {
    display: inline-flex;
    align-items: center;
  }

  a.link--external:not(.link--card-hero) .link--external__icon {
      width: 1rem;
      height: 1rem;
      margin-left: 0.5rem;
      vertical-align: baseline;
    }

  a.link--cta-card {
  display: flex;
}

  a.link--cta-card {
  height: 100%;
}

  a.link--cta-card {
  flex-direction: column;
}

  a.link--cta-card {
    align-items: inherit;
  }

  a.link--cta-card:hover {
  text-decoration: none;
}

  a.link--nav-flyout__sub-link, a.link--nav-flyout__link {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

  a.link--nav-flyout__sub-link:hover, a.link--nav-flyout__link:hover {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

  a.link--nav-flyout__sub-link:hover, a.link--nav-flyout__link:hover {
  text-decoration: underline;
}

  a.link--location-card-map {
  display: flex;
}

  a.link--location-card-map {
  width: 100%;
}

  a.link--location-card-map {
  font-size: 1.25rem;
}

  a.link--location-card-map:hover {
  text-decoration: none;
}

  @media (min-width: 1024px) {

  a.link--location-card-map {
    display: block;
  }
}

  a.link--location-card-mapblock {
  display: flex;
}

  a.link--location-card-mapblock {
  font-size: 1.25rem;
}

  a.link--location-card-mapblock {
    margin-left: 30%;
    width: 70%
  }

  @media (min-width: 768px) {

  a.link--location-card-mapblock {
    width: 100%;
  }
}

  a.link--location-card-mapblock:hover {
  text-decoration: none;
}

  @media (min-width: 1024px) {

  a.link--location-card-mapblock {
    display: block;
  }
}

  @media (min-width: 768px) {

  a.link--location-card-mapblock {
      margin-left: auto;
      width: 100%
  }
    }

  a.link--location-card-list {
  display: flex;
}

  a.link--location-card-list:hover {
  text-decoration: none;
}

  @media (min-width: 1024px) {

  a.link--location-card-list {
    display: block;
  }
}

.white {
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.white:hover {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.white:hover {
  text-decoration: underline;
}
`;